import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTransferNotifications } from '../contexts/TransferNotificationsContext';
import './TransferBadge.css';

const TransferBadge = () => {
  const [animate, setAnimate] = useState(false);
  // pendingCount/previousCount are shared context state — ViewPendingTransfers
  // writes to them too (via updatePendingCount) whenever it refetches, so an
  // action taken there is reflected here immediately, not just on this
  // component's own poll cycle.
  const { refreshTimestamp, pendingCount, previousCount, updatePendingCount } =
    useTransferNotifications();

  const fetchPendingCount = async () => {
    try {
      const response = await axios.get('/transfers/pending-count');
      updatePendingCount(response.data.count);
    } catch (error) {
      console.error('Error fetching pending transfer count:', error);
    }
  };

  useEffect(() => {
    // Fetch count whenever refreshTimestamp changes
    fetchPendingCount();

    // Set up polling interval — catches changes made by someone else (e.g.
    // the other party in a transfer) that ViewPendingTransfers isn't open to
    // pick up on its own poll.
    const interval = setInterval(fetchPendingCount, 30000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshTimestamp]); // Add refreshTimestamp as a dependency

  useEffect(() => {
    if (pendingCount !== previousCount) {
      setAnimate(true);
      const timeout = setTimeout(() => setAnimate(false), 500);
      return () => clearTimeout(timeout);
    }
  }, [pendingCount, previousCount]);

  // Don't render anything if count is 0
  if (!pendingCount) return null;

  return (
    <span
      className={`transfer-badge ${animate ? 'badge-update' : ''}`}
      aria-label={`${pendingCount} pending transfers`}
    >
      {pendingCount}
    </span>
  );
};

export default TransferBadge;
